import React from 'react';

// PDF simple y autocontenido (no depende de pdfCssString.js, armado para el
// reporte de 4 páginas de expensas). Lo emite expensas360 a su cliente
// (la administradora), por eso el logo es siempre el de expensas360, no el
// de localStorage.administracionLogo (ese es el logo del cliente).
const LOGO_EXPENSAS360 = 'assets/layout/images/administradoras/expensas360.png';

const fmtMoneda = (v) => `$ ${Number(v || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;

const thStyle = { padding: '8px 10px', textAlign: 'left', border: '1px solid #1a3c5e', color: '#fff' };
const tdStyle = { padding: '8px 10px', border: '1px solid #e0e0e0' };

const ReporteLiquidacionAdministracion = ({ administracion, periodoStr, filas = [], totalGeneral = 0 }) => {
    return (
        <div style={{ fontFamily: 'Arial, sans-serif', width: '190mm', padding: '10mm', color: '#222', backgroundColor: '#fff' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid #1a3c5e', paddingBottom: '12px', marginBottom: '20px' }}>
                <img src={LOGO_EXPENSAS360} alt="expensas360" style={{ maxWidth: '180px', maxHeight: '80px', objectFit: 'contain' }} />
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a3c5e' }}>Liquidación Mensual</div>
                    <div style={{ fontSize: '14px', color: '#555' }}>{periodoStr}</div>
                </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '14px', color: '#555' }}>Administradora</div>
                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1a3c5e' }}>{administracion}</div>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                    <tr style={{ backgroundColor: '#1a3c5e' }}>
                        <th style={thStyle}>Barrio</th>
                        <th style={{ ...thStyle, textAlign: 'right' }}>Cant. UF</th>
                        <th style={{ ...thStyle, textAlign: 'right' }}>Monto por UF</th>
                        <th style={{ ...thStyle, textAlign: 'right' }}>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {filas.map((f, i) => (
                        <tr key={f.barrioId} style={{ backgroundColor: i % 2 === 0 ? '#f8f9fb' : '#fff' }}>
                            <td style={tdStyle}>{f.nombreBarrio}</td>
                            <td style={{ ...tdStyle, textAlign: 'right' }}>{f.cantidadUF}</td>
                            <td style={{ ...tdStyle, textAlign: 'right' }}>{fmtMoneda(f.montoPorUF)}</td>
                            <td style={{ ...tdStyle, textAlign: 'right' }}>{fmtMoneda(f.totalBarrio)}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={3} style={{ ...tdStyle, textAlign: 'right', fontWeight: 'bold' }}>Total General</td>
                        <td style={{ ...tdStyle, textAlign: 'right', fontWeight: 'bold', fontSize: '15px', color: '#1a3c5e' }}>{fmtMoneda(totalGeneral)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default ReporteLiquidacionAdministracion;
